import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {

  url1: boolean = true;
  constructor(private router: Router) { }

  ngOnInit() {
    if(this.router.url.includes('lead/newnoauth')){
      this.url1 = false;
    }
  }

}
